import View from './view';
import {useSelector} from 'react-redux';
import {profilePhotoSelector} from '../../../redux/selectors/profile';
import {InputModel} from './model';

export const HolderAvatar = (props: InputModel) => {
  const photo = useSelector(profilePhotoSelector());
  return View({...props, photo});
};
